export default __webpack_public_path__ + "11fcb671fde45cde64719958990427fa.png";